import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(3),
  },
  asapAlert: {
    minWidth: '100%',
    marginBottom: theme.spacing(2),
  },
  reminderAlert: {
    minWidth: '100%',
    marginBottom: theme.spacing(2),
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}))

export default useStyles
